import { __assign } from "tslib";
import { alpha } from '@mui/material';
import { createBreakpoints } from '@mui/system';
var breakpoints = createBreakpoints({});
export var AlertTheme = function (theme) {
    var _a;
    return ({
        defaultProps: {},
        styleOverrides: {
            root: function (_a) {
                var ownerState = _a.ownerState, theme = _a.theme;
                return (__assign(__assign(__assign(__assign({ borderRadius: 4, 
                    // padding: `12px 16px`,
                    padding: theme.spacing(1.5, 2), boxSizing: "border-box", lineHeight: 'initial' }, (ownerState.color === undefined && {
                    color: theme.palette.greySecondary.main,
                    backgroundColor: alpha(theme.palette.greySecondary[50], 0.5),
                    '.MuiAlert-icon': {
                        color: theme.palette.greySecondary.main,
                    },
                })), ((!ownerState.variant) && __assign(__assign({}, (ownerState.color && {
                    color: theme.palette.text.primary,
                    backgroundColor: alpha(theme.palette[ownerState.color][50], 0.5),
                })), (ownerState.color === undefined && {
                    backgroundColor: theme.palette.greySecondary.main,
                })))), (ownerState.variant &&
                    ownerState.variant === 'outlined' && __assign(__assign({}, (ownerState.color && {
                    backgroundColor: alpha(theme.palette[ownerState.color][50], 0.5),
                    border: "1px solid ".concat(theme.palette[ownerState.color][200]),
                })), (ownerState.color === undefined && {
                    border: "1px solid ".concat(theme.palette.greySecondary[200]),
                    backgroundColor: alpha(theme.palette.greySecondary[50], 0.5),
                    '.MuiAlert-icon': {
                        color: theme.palette.greySecondary.main,
                    },
                })))), (ownerState.variant &&
                    ownerState.variant === 'filled' && __assign({}, (ownerState.color === undefined && {
                    color: theme.palette.greySecondary.contrastText,
                    backgroundColor: theme.palette.greySecondary.main,
                    '.MuiAlert-icon': {
                        color: theme.palette.greySecondary.contrastText,
                    },
                })))));
            },
            icon: function (_a) {
                var theme = _a.theme;
                return ({
                    marginRight: theme.spacing(1),
                    padding: 0,
                    alignItems: "center"
                });
            },
            message: (_a = {
                    display: "flex",
                    alignItems: "center",
                    padding: 0,
                    fontSize: theme.typography.body1.fontSize
                },
                _a[breakpoints.down('sm')] = {
                    fontSize: "0.813rem", //13
                },
                _a),
            action: {
                padding: 0,
                paddingLeft: 16,
                alignItems: "center"
            }
        },
        variants: [
            {
                props: { variant: 'filled', color: 'warning' },
                style: {
                    color: theme.palette.warning.contrastText,
                },
            },
        ],
    });
};
export default AlertTheme;
//# sourceMappingURL=theme.js.map